import React from 'react';
import { useLocation } from 'react-router-dom';
import NoteTakingPad from './NoteTakingPad';

// Routes where the note-taking pad should appear
const ENABLED_ROUTES = [
  '/workbook',
  '/belonging-ebook',
  '/teachers-guide',
  '/ofnr-trainer',
  '/lore',
  '/dashboard',
  '/elchme',
  '/wisdom-library',
  '/chapter'
];

// Routes where the note-taking pad should NOT appear
const EXCLUDED_ROUTES = [
  '/',
  '/admin',
  '/login',
  '/forgot-password',
  '/onboarding',
  '/payment',
  '/directions'
];

export default function GlobalNoteTakingPad() {
  const location = useLocation();
  const pathname = location.pathname;

  // Check if current route should show the note pad
  const shouldShow = ENABLED_ROUTES.some(route => pathname.startsWith(route)) &&
                     !EXCLUDED_ROUTES.includes(pathname);

  // Get page context from pathname
  const getPageContext = () => {
    if (pathname.startsWith('/workbook/')) {
      // Extract page name from path like /workbook/feelings-needs-exercise
      const pageName = pathname.replace('/workbook/', '').replace(/-/g, ' ');
      return `Workbook: ${pageName}`;
    }
    if (pathname.startsWith('/belonging-ebook')) return 'Belonging eBook';
    if (pathname.startsWith('/teachers-guide')) return 'Belonging eBook';
    if (pathname.startsWith('/ofnr-trainer')) return 'OFNR Trainer';
    if (pathname.startsWith('/lore')) return 'LORE Practice';
    if (pathname.startsWith('/dashboard')) return 'Dashboard';
    if (pathname.startsWith('/elchme')) return 'ElchmE Board';
    if (pathname.startsWith('/wisdom-library')) return 'Wisdom Library';
    if (pathname.startsWith('/chapter')) return 'Chapter View';
    return 'General';
  };

  if (!shouldShow) {
    return null;
  }

  return (
    <NoteTakingPad 
      pageContext={getPageContext()}
      userId={localStorage.getItem('userId')}
    />
  );
}
